import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';
import eventInfo from '../../../../../lib/components/eventInfo';
import primaryClaimEditor from '../primaryClaimEditor';
import secondaryClaimEditor from '../secondaryClaimEditor';
import confirmModal from '../../../../../lib/components/modals/confirmModal';
import errorList from '../../../../../lib/components/errorList';
import { DEBUG } from '../../../../../lib/constants';
import translationModuleName from '../../../../../lib/translation';
import positionSearchFormModule from '../positionSearchForm';

// Controller
import PositionSearchModalController from './positionSearchModal.controller';
import template from './positionSearchModal.html';

const moduleName = 'staff.dashboardScreen.positionSearchModal';
let module = angular.module(moduleName, [
  uiModal,
  'recaps.services',
  'constants',
  eventInfo.name,
  primaryClaimEditor.name,
  secondaryClaimEditor.name,
  confirmModal.name,
  errorList.name,
  translationModuleName,
  positionSearchFormModule.name,
]);

module.controller('PositionSearchModalController', PositionSearchModalController);

module.factory('showPositionSearchModal', ['$uibModal', '$q', ($uibModal, $q) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: PositionSearchModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        DEBUG: () => DEBUG,
        staffUser: () => props.staffUser,
      }
    });
    return modal.result;
  };
}]);

export default module;
